import styled from "styled-components";
export const ButtonSet = styled.div`
  gap: 3vw;
  display: flex;
  /* margin-top: 10px; */

  button {
    background-color: #233354;
    color: rgb(255, 255, 255);
    border: none;
    padding: 12px;
    font-size: 16px;
    width: 155px;
    margin-top: min(1.75vw, 25px);
    @media (max-width: 1023px) {
      width: 215px !important;
    }
  }
  @media (max-width: 767px) {
    flex-direction: column;
    align-items: center;
  }
`;
